(function () {
  function initDiscountScript() {
    const $appliedDiscountsContainer = $('#applied-discounts');
    const $applyBtn = $('#apply-discount-btn');
    const $discountInput = $('#discount-input');

    if (!$appliedDiscountsContainer.length || !$applyBtn.length || !$discountInput.length) return;

    const strings = window.cartDiscountStrings || {};
    const MSG_NO_CODE = strings.errorNoCode || "Please enter a discount code.";
    const MSG_ALREADY_APPLIED = strings.errorAlreadyApplied || "That discount code is already applied.";
    const MSG_INVALID = strings.errorInvalid || "Discount code is invalid or not applicable.";

    function clearMessages() {
      $('#discount-error-message').hide().text('');
    }

    function showError(msg) {
      $('#discount-error-message').show().text(msg);
    }

    function getCurrentDiscounts() {
      return $('#applied-discounts .discount-pill')
        .map(function () {
          return $(this).data('code').toUpperCase();
        }).get();
    }

    function triggerCartUpdate() {
      const cartDrawerItems = $('cart-drawer-items')[0];
      if (cartDrawerItems && typeof cartDrawerItems.updateQuantity === 'function') {
        const qtyInput = $('#Drawer-quantity-1, #Quantity-1').first();
        if (qtyInput.length) {
          const currentQty = parseInt(qtyInput.val(), 10) || 1;
          cartDrawerItems.updateQuantity(1, currentQty);
        } else {
          cartDrawerItems.onCartUpdate();
        }
        return;
      }

      const cartItems = $('cart-items')[0];
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        const qtyInput = $('#Quantity-1, #Drawer-quantity-1').first();
        if (qtyInput.length) {
          const currentQty = parseInt(qtyInput.val(), 10) || 1;
          cartItems.updateQuantity(1, currentQty);
        } else {
          cartItems.onCartUpdate();
        }
      }
    }

    async function applyDiscounts(discountCodes = []) {
      let isRemoving = false;
      if (discountCodes.length === 0) {
        discountCodes = ['REMOVE_SHOPIFY_CODE'];
        isRemoving = true;
      }

      const discountString = discountCodes.join(',');
      const checkoutUrl = `/checkout?discount=${encodeURIComponent(discountString)}`;

      try {
        await fetch(checkoutUrl, { method: 'GET' });
      } catch (err) {}

      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();

      const validSet = new Set();
      (cartData.cart_level_discount_applications || []).forEach(d => validSet.add(d.title.toUpperCase()));
      cartData.items.forEach(item => {
        (item.line_level_discount_allocations || []).forEach(a => {
          validSet.add(a.discount_application.title.toUpperCase());
        });
      });

      const invalidCodes = discountCodes.filter(c => !validSet.has(c.toUpperCase()));
      const newlyAddedCode = discountCodes[discountCodes.length - 1];
      const codeIsInvalid = invalidCodes.includes(newlyAddedCode);

      if (newlyAddedCode === 'REMOVE_SHOPIFY_CODE' || !codeIsInvalid) {
        triggerCartUpdate();
      }

      return {
        success: !codeIsInvalid || isRemoving,
        invalidCodes
      };
    }

    // ✅ Apply Discount Handler
    $(document).on('click', '#apply-discount-btn', async function () {
      clearMessages();

      const existingCodes = getCurrentDiscounts();
      let newCode = $discountInput.val().trim().toUpperCase();

      if (!newCode) {
        showError(MSG_NO_CODE);
        return;
      }

      if (existingCodes.includes(newCode)) {
        showError(MSG_ALREADY_APPLIED);
        return;
      }

      // Show apply button spinner
      $(this).find('.discount-spinner').removeClass('hidden');

      const combinedCodes = [...existingCodes, newCode];
      const result = await applyDiscounts(combinedCodes);

      // Hide spinner
      $(this).find('.discount-spinner').addClass('hidden');

      if (result.invalidCodes.map(c => c.toUpperCase()).includes(newCode)) {
        showError(MSG_INVALID);
      }

      console.log('addcart');
    });

    // ✅ Remove Discount Handler
    $(document).on('click', '.remove-discount', async function () {
      clearMessages();

      const $pill = $(this).closest('.discount-pill');
      const codeToRemove = $pill.data('code');
      if (!codeToRemove) return;

      // Show remove button spinner
      $(this).find('.remove-spinner').removeClass('hidden');

      const existingCodes = getCurrentDiscounts();
      const newDiscountList = existingCodes.filter(c => c !== codeToRemove.toUpperCase());
      await applyDiscounts(newDiscountList);

      // Hide spinner
      $(this).find('.remove-spinner').addClass('hidden');

      console.log('removecart');
    });
  }

  $(document).ready(() => {
    initDiscountScript();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      initDiscountScript();
    });
  }
})();


